import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "image", "container"];

  declare modalTarget : HTMLElement;
  declare imageTarget : HTMLImageElement;
  declare containerTarget : HTMLElement;

  displayImageModal(event: Event) : void {
    event.stopPropagation();

    const imageElement = event.currentTarget as HTMLElement
    const url = imageElement.dataset["url"]

    if (url != undefined){
      this.imageTarget.src = url;
      this.modalTarget.classList.add("is-active");
    }
  }

  closeImageModal() : void {
    this.modalTarget.classList.remove("is-active");
  }

  toggleImages(event: Event): void {
    this.containerTarget.classList.toggle("is-hidden");
    const target = event.target as HTMLElement;
    target.classList.toggle("fa-angle-down");
    target.classList.toggle("fa-angle-up");
  }

  confirmRemove(event: Event): void {
    const response = confirm("Are you sure you want to remove this image?");
    if (response == true) {
      return;
    } else {
      event.preventDefault();
    }
  }
}
